"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledDropdownLi = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _context = require("../../context");

var _DropdownContext = require("../../form/select/dropdown/DropdownContext");

var _utils = require("../../utils");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["getItemProps", "renderItem", "isHighlighted", "item", "index", "itemAsString", "selectedItemsAsString", "isSelected", "isNavigation"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledDropdownLi = (0, _context.styledWithTheme)('li')(function (_ref) {
  var _ref$theme = _ref.theme,
      selectors = _ref$theme.selectors,
      isInHighContrast = _ref$theme.isInHighContrast,
      isHighlighted = _ref.isHighlighted,
      isSearchable = _ref.isSearchable,
      isSelectedNavigation = _ref.isSelectedNavigation,
      withCustomSelectionOptions = _ref.withCustomSelectionOptions;
  var backgroundColor;

  if (isSelectedNavigation) {
    backgroundColor = isHighlighted ? _constants.NAVIGATION_HIGHLIGHT_COLOR : _constants.NAVIGATION_SELECTED_COLOR;
  } else {
    backgroundColor = isHighlighted ? _constants.HIGHLIGHT_COLOR : 'neutral0';
  }

  var borderColor = selectors.color(_constants.BORDER_COLOR);
  var topShadow = "inset 0px 2px 0px -1px ".concat(borderColor);
  var bottomShadow = "inset 0px -2px 0px -1px ".concat(borderColor);
  var highlightedStyles = isSearchable ? {
    boxShadow: "".concat(bottomShadow, ", ").concat(topShadow),
    ':last-of-type': {
      boxShadow: topShadow
    }
  } : {
    ':not(:first-of-type):not(:last-of-type)': {
      boxShadow: "".concat(bottomShadow, ", ").concat(topShadow)
    },
    ':first-of-type:not(:last-of-type)': {
      boxShadow: bottomShadow
    },
    ':last-of-type:not(:first-of-type)': {
      boxShadow: topShadow
    }
  };
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    fontFamily: selectors.fontFamily('primary'),
    fontSize: selectors.fontSize(_constants.FONT_SIZE),
    lineHeight: selectors.lineHeight(_constants.FONT_SIZE),
    color: selectors.color(_constants.TEXT_COLOR),
    backgroundColor: selectors.color(backgroundColor),
    cursor: 'pointer',
    padding: (0, _utils.px)(selectors.space(_constants.ITEM_PADDING))
  }, withCustomSelectionOptions ? {
    paddingLeft: (0, _utils.px)(selectors.space(_constants.ITEM_WITH_GROUPING_LEFT_PADDING))
  } : {}), isHighlighted ? highlightedStyles : {}), isHighlighted && isInHighContrast ? {
    outlineStyle: 'solid',
    outlineOffset: '-2px'
  } : {}), {}, {
    ':not(:last-of-type)': {
      borderBottom: "".concat((0, _utils.px)(_constants.DIVIDER_WIDTH), " solid ").concat(borderColor)
    }
  });
});
exports.StyledDropdownLi = StyledDropdownLi;

var DropdownLi = function DropdownLi(_ref2) {
  var getItemProps = _ref2.getItemProps,
      renderItem = _ref2.renderItem,
      isHighlighted = _ref2.isHighlighted,
      item = _ref2.item,
      index = _ref2.index,
      itemAsString = _ref2.itemAsString,
      selectedItemsAsString = _ref2.selectedItemsAsString,
      isSelected = _ref2.isSelected,
      isNavigation = _ref2.isNavigation,
      htmlProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useContext = (0, _react.useContext)(_DropdownContext.DropdownContext),
      isSearchable = _useContext.isSearchable,
      withCustomSelectionOptions = _useContext.withCustomSelectionOptions;

  var renderedItem = !!renderItem ? renderItem(item, {
    isHovered: isHighlighted
  }) : item; // Override default Downshift behavior which is aria-selected on hover
  // Use aria-selected to mark selected items in multi-select
  // Don't use aria-selected at all in single select because of inconsistent behavior in Screen Readers

  var selectedItemProps = selectedItemsAsString ? {
    'aria-selected': selectedItemsAsString.includes(itemAsString)
  } : {
    'aria-selected': undefined
  };
  return (0, _core.jsx)(StyledDropdownLi, (0, _extends2.default)({
    isHighlighted: isHighlighted,
    isSearchable: isSearchable,
    isSelectedNavigation: isSelected && isNavigation,
    withCustomSelectionOptions: withCustomSelectionOptions
  }, !!getItemProps ? getItemProps({
    item: item,
    index: index
  }) : {}, selectedItemProps, htmlProps), renderedItem);
};

DropdownLi.displayName = 'DropdownLi';

var _default = /*#__PURE__*/(0, _react.memo)(DropdownLi);

exports.default = _default;